import { BackendModule } from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { envVariableOrDefault } from '../constants';

const LOCALIZATION_URL = envVariableOrDefault(
  '$APP_LOCALIZATION_URL',
  process.env.REACT_APP_LOCALIZATION_URL || ' '
);

export const l10nBackendModuleAzure = (): BackendModule => {
  return new HttpBackend(null, {
    loadPath: `${LOCALIZATION_URL}/{{ns}}.{{lng}}.json`,
    crossDomain: true,
    requestOptions: {
      mode: 'no-cors',
    },
    queryStringParams: { hash: `${Date.now()}` },
  });
};
